import { querySelector, querySelectorAll } from '../functions/querySelectors';
import { xhrLoad } from '../functions/xhrLoad';
import insertScript from '../functions/insertScript';
import offsetTop from '../functions/offsetTop';
import getScrollTop from '../functions/getScrollTop';
import { setListenersFromSelector } from '../functions/listeners';
import scrollBehavior from '../functions/scrollBehavior';
import isMobile from '../functions/isMobile';
import { BREAKPOINT_MEDIUM, BREAKPOINT_XLARGE } from '../config/breakpoints';
import { U_DN_CLASS } from '../config/main';
import paging from '../functions/paging';
import afterUpdate from '../modules/afterUpdate';

export const PAGING_CLASS = 'c-ajax-paging';
export const PAGING_START_CLASS = `${PAGING_CLASS}--start`;
export const PAGING_NO_SHADOW_CLASS = `${PAGING_CLASS}--no-shadow`;
const PAGING_LINK_CLASS = `${PAGING_CLASS}__link`;
const PAGING_LINK_INIT_CLASS = 'capl-init';
export const ITEMS_CLASS = 'js-ajax-items';
const STOP_NEXT_CLASS = 'js-ajax-stop';
const STOP_PREV_CLASS = 'js-ajax-prev-stop';
const NEXT_CLASS = 'js-ajax-next-url';
const PREV_CLASS = 'js-ajax-prev-url';
const LOADER_CLASS = 'js-ajax-loader';
const LOADER_SHOW_CLASS = 'w-loader--show';
export const WRAP_CLASS = 'js-ajax-wrap';
export const ACTIVE_WRAP_CLASS = 'js-ajax-wrap--active';
const BOTTOM_OFFSET = window.outerHeight * 0.5;
const ITEM_CLASS = 'c-product-boxes__item';
const ITEM_INIT_CLASS = 'cpbi-init';
const ITEM_LINK_CLASS = 'c-product-box__link';
const URL_ATTR = 'data-url';
const PREV_WRAPPER_CLASS = 'c-product-list__load-prev';
const PREV_WRAPPER_SHOW_CLASS = `${PREV_WRAPPER_CLASS}--show`;
const PREV_BTN_CLASS = 'js-load-prev';
const PREV_BTN_INIT_CLASS = 'jlp-init';
const PREV_BTN_LOADING_CLASS = 'c-product-list__load-prev-link--loading';
const NEXT_BTN_CLASS = 'js-load-next';
const NEXT_BTN_INIT_CLASS = 'jln-init';
const NEXT_BTN_LOADING_CLASS = 'c-product-list__load-next-link--loading';
const PAGE_NUMBER_ATTR = 'data-page-number';
const PAGING_LIST_CLASS = `${PAGING_CLASS}__list`;
const MAX_PAGES_ATTR = 'data-max-pages';

const BREAKPOINT_1 = 350;
const BREAKPOINT_2 = BREAKPOINT_MEDIUM;
const BREAKPOINT_3 = BREAKPOINT_XLARGE;

let lastScrollPosition = 0;
let items = null;
let actualUrl = null;
let productClicked = false;
let appendNext = null;
let hasPaging = false;
let pagingList = null;
let pagingRoot = null;

let getPageNumber = function(element) {
  return parseInt(element.getAttribute(PAGE_NUMBER_ATTR), 10) || 1;
};

let getPrevButton = function() {
  return querySelector(`.${PREV_BTN_CLASS}`);
};

let getNextButton = function() {
  return querySelector(`.${NEXT_BTN_CLASS}`);
};

let getItemJump = function() {
  if (isMobile(BREAKPOINT_1)) {
    return 1;
  }
  if (isMobile(BREAKPOINT_2)) {
    return 2;
  }
  if (isMobile(BREAKPOINT_3)) {
    return 3;
  }

  return 4;
};

let showLoader = function(wrapper) {
  let loader = querySelector(`.${LOADER_CLASS}`, wrapper);

  if (loader) {
    loader.classList.add(LOADER_SHOW_CLASS);
  }
};

let hideLoader = function(wrapper) {
  let loader = querySelector(`.${LOADER_CLASS}`, wrapper);

  if (loader) {
    loader.classList.remove(LOADER_SHOW_CLASS);
  }
};

let isNextStop = function() {
  return querySelector(`.${STOP_NEXT_CLASS}`);
};

let isPrevStop = function() {
  return querySelector(`.${STOP_PREV_CLASS}`);
};

let isLoading = function() {
  return getWrapper().classList.contains(ACTIVE_WRAP_CLASS);
};

let getWrapper = function() {
  return querySelector(`.${WRAP_CLASS}`);
};

let getFirstProductInViewport = function(scrollPosition) {
  let firstProduct = items[items.length - 1];
  let i = 0;
  let itemJump = getItemJump();

  items.every((item) => {
    if (i === 0) {
      if (scrollPosition < offsetTop(item)) {
        firstProduct = item;
        return false;
      }
    }

    i++;

    if (i === itemJump) {
      i = 0;
    }

    return true;
  });

  return firstProduct;
};

let showLoadPrev = function() {
  let prev = querySelector(`.${PREV_WRAPPER_CLASS}`);

  if (prev) {
    prev.classList.add(PREV_WRAPPER_SHOW_CLASS);
  }
};

let hideLoadPrev = function() {
  let prev = querySelector(`.${PREV_WRAPPER_CLASS}`);

  if (prev) {
    prev.classList.remove(PREV_WRAPPER_SHOW_CLASS);
  }
};

let getFirstItem = function() {
  return querySelector(`.${ITEM_CLASS}`);
};

let loadPage = function(response) {
  let loadingElement = null;
  let windowPosition = null;
  let itemPosition = null;
  let firstItem = null;
  let insertWhere = 'beforeend';
  let wrapper = getWrapper();

  if (appendNext) {
    loadingElement = querySelector(`.${NEXT_CLASS}`, wrapper);
  }
  else {
    loadingElement = querySelector(`.${PREV_CLASS}`, wrapper);
    insertWhere = 'afterbegin';
    firstItem = getFirstItem();
    windowPosition = getScrollTop();
    itemPosition = offsetTop(firstItem);
  }

  loadingElement.parentNode.removeChild(loadingElement);
  insertScript(response);
  querySelector(`.${ITEMS_CLASS}`, wrapper).insertAdjacentHTML(insertWhere, response);

  wrapper.classList.remove(ACTIVE_WRAP_CLASS);
  hideLoader();

  afterUpdate.update();

  if (!appendNext) {
    if (isPrevStop()) {
      hideLoadPrev();
    }

    scrollBehavior.disable();
    window.scrollTo(0, (offsetTop(firstItem) - itemPosition + windowPosition));
    scrollBehavior.enable();
  }

  let prevBtn = getPrevButton();

  if (prevBtn) {
    prevBtn.classList.remove(PREV_BTN_LOADING_CLASS);
  }

  let nextBtn = getNextButton();

  if (nextBtn) {
    nextBtn.classList.remove(NEXT_BTN_LOADING_CLASS);

    if (isNextStop()) {
      nextBtn.classList.add(U_DN_CLASS);
    }
  }
};

let failPage = function(response) {
  let wrapper = getWrapper();

  wrapper.classList.remove(ACTIVE_WRAP_CLASS);
  hideLoader();

  let prevBtn = getPrevButton();

  if (prevBtn) {
    prevBtn.classList.remove(PREV_BTN_LOADING_CLASS);
  }
};

let loadNext = function(next = true) {
  let loadingElement = null;
  let wrapper = getWrapper();

  if (next) {
    loadingElement = querySelector(`.${NEXT_CLASS}`, wrapper);
    appendNext = true;
  }
  else {
    loadingElement = querySelector(`.${PREV_CLASS}`, wrapper);
    appendNext = false;
  }

  let urlElement = querySelector('a', loadingElement);

  showLoader();

  wrapper.classList.add(ACTIVE_WRAP_CLASS);

  xhrLoad(
    urlElement,
    loadPage,
    failPage
  );
};

let prevClick = function(event) {
  event.preventDefault();

  let prevBtn = getPrevButton();

  if (prevBtn) {
    prevBtn.classList.add(PREV_BTN_LOADING_CLASS);
  }

  if (!isPrevStop()) {
    loadNext(false);
  }
};

let nextClick = function(event) {
  event.preventDefault();

  let nextBtn = getNextButton();

  if (nextBtn) {
    nextBtn.classList.add(NEXT_BTN_LOADING_CLASS);
  }

  if (!isNextStop()) {
    loadNext();
  }
};

let pageItemClick = function(event) {

};

let setPaging = function(newPageNumber) {
  paging(
    pagingList,
    {
      size: parseInt(pagingList.getAttribute(MAX_PAGES_ATTR), 10),
      page: newPageNumber,
      step: isMobile() ? 1 : 2
    }
  );
};

let setActiveItem = function(firstInViewport) {
  let newUrl = firstInViewport.getAttribute(URL_ATTR);

  if (newUrl !== actualUrl) {
    window.history.replaceState({}, null, newUrl);
    actualUrl = newUrl;
    setPaging(getPageNumber(firstInViewport));
  }
};

let windowScroll = function() {
  let wrapper = getWrapper();

  if (wrapper) {
    let scrollPosition = getScrollTop();

    if (getNextButton() === null) {
      if (scrollPosition > lastScrollPosition) { //downscroll
        if (wrapper.offsetTop + wrapper.offsetHeight < scrollPosition + window.innerHeight + BOTTOM_OFFSET) {
          if (!isLoading() && !isNextStop()) {
            loadNext(true);
          }
        }
      }
    }

    if (hasPaging) {
      let firstInViewport = getFirstProductInViewport(scrollPosition);
      setActiveItem(firstInViewport);
    }

    lastScrollPosition = scrollPosition <= 0 ? 0 : scrollPosition;
  }
};

let itemClick = function(event) {
  //  http://stackoverflow.com/questions/20087368/how-to-detect-if-user-it-trying-to-open-a-link-in-a-new-tab
  if (event.ctrlKey || event.shiftKey || event.metaKey || (event.button && event.button === 1) || productClicked) {
    return;
  }

  window.removeEventListener('scroll', windowScroll);

  event.preventDefault();
  event.stopPropagation();

  let productPageUrl = this.getAttribute(URL_ATTR);
  let windowPosition = getScrollTop();
  let itemPosition = offsetTop(this);

  items.forEach((item) => {
    if (item.getAttribute(URL_ATTR) !== productPageUrl) {
      item.parentNode.removeChild(item);
    }
  });

  if (productPageUrl.indexOf('?') !== -1) {
    showLoadPrev();
  }

  scrollBehavior.disable();
  window.scrollTo(0, (offsetTop(this) - itemPosition + windowPosition));
  scrollBehavior.enable();

  window.history.replaceState({}, null, productPageUrl);

  productClicked = true;

  let link = querySelector(`.${ITEM_LINK_CLASS}`, this);
  link.click();
};

let setItemListeners = function() {
  setListenersFromSelector(
    `.${ITEM_CLASS}`,
    ITEM_INIT_CLASS,
    itemClick
  );
};

let doOnStart = function() {
  items = querySelectorAll(`.${ITEM_CLASS}`, getWrapper());
  let firstInViewport = getFirstProductInViewport(getScrollTop());
  setPaging(getPageNumber(firstInViewport));
};

let whenUpdate = function() {
  items = querySelectorAll(`.${ITEM_CLASS}`, getWrapper());

  setItemListeners();
};

export function paging2() {
  if (querySelector(`.${ITEMS_CLASS}`)) {
    items = querySelectorAll(`.${ITEM_CLASS}`, getWrapper());

    window.addEventListener('scroll', windowScroll);

    afterUpdate.add(() => {
      actualUrl = window.location.pathname + window.location.search;
      pagingRoot = querySelector(`.${PAGING_CLASS}`);
      hasPaging = !!pagingRoot;
      pagingList = querySelector(`.${PAGING_LIST_CLASS}`);

      if (hasPaging) {
        setListenersFromSelector(
          `.${PREV_BTN_CLASS}`,
          PREV_BTN_INIT_CLASS,
          prevClick
        );

        setListenersFromSelector(
          `.${NEXT_BTN_CLASS}`,
          NEXT_BTN_INIT_CLASS,
          nextClick
        );

        setListenersFromSelector(
          `.${PAGING_LINK_CLASS}`,
          PAGING_LINK_INIT_CLASS,
          pageItemClick
        );

        doOnStart();
        setItemListeners();
      }
    })();

    afterUpdate.add(whenUpdate);
  }
};
